export default {
    knowledgeList:[
        {
            tit:'方剂识别',
            txt:'快速识别方剂组成，返回相似方剂',
            img:require('../../assets/images/home/fj-icon.png'),
            changeflag:2,
            path:'recognizeFj', 
        },
        {
            tit:'文献标注',
            txt:'自定义标记信息，导出结构化数据',
            img:require('../../assets/images/home/wxbj-icon.png'),
            changeflag:2,
            path:'', 
        },
        {
            tit:'文献计量',
            txt:'文献量化分析及可视化，辅助科研',
            img:require('../../assets/images/home/wxjl-icon.png'), 
            changeflag:2,
            path:'bibliometric', 
        },
        {
            tit:'构建知识图谱',
            txt:'知识图谱数据整理及生成工具',
            img:require('../../assets/images/home/gj-icon.png'),
            changeflag:2,
            path:'atlas', 
        } ,
        {
            tit:'智能养生问答',
            txt:'知识库与大模型相融合的养生助手',
            img:require('../../assets/images/home/wd-icon.png'),
            changeflag:2,
            path:'intellAnswer', 
        }
    ],
    studyList:[
        {
            tit:'学古籍',
            txt:'梳理挖掘古典医籍精华，系统学习中医药古籍知识',
            img:require('../../assets/images/home/study-gj.png'),
            imgHover:require('../../assets/images/home/study-gj-active.png'),
            mouseenter:true,
            isClick:true,
            path:'studyPage',
            changeflag:3,
            list:[]
        },
        {
            tit:'学临床',//现有网站的专科专病
            txt:'了解中医药临床诊疗指南，学习中医药辨证论治技巧',
            img:require('../../assets/images/home/study-zd.png'),
            imgHover:require('../../assets/images/home/study-zd-active.png'),
            mouseenter:false,
            isClick:false, 
            path:'clinic',
            changeflag:3, 
            list:[]
        },
        {
            tit:'学中药',
            txt:'中药知识大百科，全面掌握药物的药典、文献等相关记载',
            img:require('../../assets/images/home/study-zy.png'),
            imgHover:require('../../assets/images/home/study-zy-active.png'),
            mouseenter:false,
            isClick:false,
            changeflag:3,
            path:'',  
            list:[]
        },
        {
            tit:'查题库',//数据资源里的中医题库
            txt:'集成中医药各类型试题题面、答案及分析，辅助专业学习及考试',
            img:require('../../assets/images/home/study-tk.png'),
            imgHover:require('../../assets/images/home/study-tk-active.png'),
            mouseenter:false,
            isClick:false,
            changeflag:3,
            path:'',
            list:[
                {
                    tit:'金匮要略',
                    sublevel:['单选题 ','多选题  ','比较选择题  ','多选K型题 ','名词解释 ','判断题  ','填空题  ','简答题  ']
                },
                {
                    tit:'各家学说',
                    sublevel:['单选题 ','多选题  ','组合单选题 ','名词解释 ','填空题  ','判断题  ','简答题  ','论述题']
                },
                {
                    tit:'中医内科主治医师资格考试',
                    sublevel:['单选题 ','多选题  ','组合单选题','病案单选题  ','病案分析题  ']
                },
            ]
        },
        // {
        //     tit:'学专题',
        //     txt:'更多实用、方便的学习工具，敬请期待……',
        //     img:require('../../assets/images/home/study-zt.png'),
        //     imgHover:require('../../assets/images/home/study-zt-active.png'),
        //     mouseenter:false,
        //     isClick:false,
        //     changeflag:3,
        //     path:'',
        //     list:[]
        // },
    ],
    subjectList:[
        {
            pic:require('../../assets/images/home/subject-pic1.png'),
            tit:'临证指南医案数据挖掘',
            path:'',
            changeflag:4,
            list:[
                {val:'三千多医案数据',type:''},
                {val:'多维度统计分析',type:''},
                {val:'可视化展示结果',type:''},
                {val:'一键式分析报告',type:''},
            ]
        },
        {
            pic:require('../../assets/images/home/subject-pic2.png'),
            tit:'伤寒论全文阅读及解析',
            path:'',
            changeflag:4,
            list:[
                {val:'伤寒论全文阅读',type:''},
                {val:'伤寒论398条原文解析',type:''},
                {val:'110首经典古方',type:''},
                {val:'海量案例关联推荐',type:''},
                {val:'理论、实践同步学',type:''},
            ]
        }
    ],
    newsNav:[
        {
            tabVal:'一周热点',
            changeflag:5,
        },
        {
            tabVal:'今日新闻',
            changeflag:5,
 
        },
         
    ],
    resourceList:[
        { 
            tit:'中药',
            txt:'「中药及制剂」',
            img:require('../../assets/images/home/resource-zy.png'),
            imgHover:require('../../assets/images/home/resource-zy-active.png'),
            mouseenter:true, 
            changeflag:6,
            path:'',
            list:[
                { val:'中药材 ',type:''},
                { val:'中成药',type:''},
                { val:'中国药典 ',type:''},
                { val:'药食同源',type:''},
                { val:'国家基本药物 ',type:''},
                { val:'院内制剂 ',type:''},
                { val:'方剂 ',type:''},
                { val:'经典名方',type:''},
                { val:'偏验方',type:''},
                { val:'国医大师经方',type:''},
                { val:'药物不良反应',type:''},
                { val:'民族医药 ',type:''},
            ]
        },
        {

            tit:'针灸',
            txt:'「针灸及验方」',
            img:require('../../assets/images/home/resource-zj.png'),
            imgHover:require('../../assets/images/home/resource-zj-active.png'),
            mouseenter:false, 
            changeflag:6,
            path:'',
            list:[
                { val:'经络',type:''},
                { val:'腧穴',type:''},
                { val:'针灸验方',type:''}, 
            ]
        },
        {
            tit:'名医',
            txt:'「名医经验」',
            img:require('../../assets/images/home/resource-my.png'),
            imgHover:require('../../assets/images/home/resource-my-active.png'),
            mouseenter:false, 
            changeflag:6,
            path:'',
            list:[
                { val:'名医简介',type:''},
                { val:'名医理论',type:''},
                { val:'名医方剂',type:''},
                { val:'名医养生',type:''},
                { val:'名医诊疗技术',type:''}, 
                { val:'名医医案',type:''}, 
            ]
        },
        {
            tit:'医案',
            txt:'「临证医案」',
            img:require('../../assets/images/home/resource-ya.png'),
            imgHover:require('../../assets/images/home/resource-ya-active.png'),
            mouseenter:false, 
            changeflag:6,
            path:'',
            list:[
                { val:'古代医案',type:''},
                { val:'现代医案',type:''},
                { val:'名医医案',type:''}, 
            ]
        },
        {
            tit:'指南',
            txt:'「指南规范」',
            img:require('../../assets/images/home/resource-zn.png'),
            imgHover:require('../../assets/images/home/resource-zn-active.png'),
            mouseenter:false, 
            changeflag:6,
            path:'',
            list:[
                { val:'指南共识',type:''},
                { val:'技术规范',type:''},
                { val:'临床路径',type:''},
                { val:'诊疗术语',type:''},
                { val:'标准编码',type:''},
                { val:'卫生标准',type:''},
                { val:'法律法规',type:''}, 
            ]
        },
        {
            tit:'养生',
            txt:'「中医养生」',
            img:require('../../assets/images/home/resource-ys.png'),
            imgHover:require('../../assets/images/home/resource-ys-active.png'),
            mouseenter:false, 
            changeflag:6,
            path:'',
            list:[
                { val:'节气养生',type:''},
                { val:'药膳养生',type:''},
                { val:'食物养生',type:''},
                { val:'按摩养生',type:''},
                { val:'气功养生',type:''},
                { val:'药物养生',type:''},
                { val:'针灸养',type:''}, 
            ]
        },
        {
            tit:'文献',
            txt:'「中医文献」',
            img:require('../../assets/images/home/resource-wx.png'),
            imgHover:require('../../assets/images/home/resource-wx-active.png'),
            mouseenter:false, 
            changeflag:6,
            path:'',
            list:[
                { val:'古代文献',type:''},
                { val:'海外古籍',type:''},
                { val:'民国期刊文献',type:''},
                { val:'现代期刊文献',type:''},
                { val:'报纸',type:''},
                { val:'专利',type:''},
                { val:'现代图书',type:''},
                { val:'英文文献',type:''},
            ]
        },
        {
            tit:'科研',
            txt:'「中医科研」',
            img:require('../../assets/images/home/resource-ky.png'),
            imgHover:require('../../assets/images/home/resource-ky-active.png'),
            mouseenter:false, 
            changeflag:6,
            path:'',
            list:[
                { val:'中医循证',type:''},
                { val:'语料库',type:''},
                { val:'中医优势病种',type:''},
                { val:'国家自然科学基金',type:''}, 
            ]
        }
    ],
    // 这里新增内容后，customize/customizeData.js里也要加对应的详情信息
    customizationList:[
        {
            tit:'中成药用药临床证据综合评价',
            cooperator:'湖南汉森制药股份有限公司等',
            txt:'基于文献材料，提供中成药的文献检索、分类与分析服务，对中成药用药临床证据进行评价。',
            changeflag:7,
            sequence:1,
        },
        {
            tit:'中医消化疾病循证大数据平台',
            cooperator:'中国中医科学院西苑医院',
            txt:'中医消化疾病循证大数据平台，是在中国中医药循证医学中心消化疾病协同创新联盟领导下，由中国中医科学院西苑医院脾胃病研究所和中国中医科学院中医药信息研究所大健康智能研发中心牵头，整合包括13个全国脾胃病区域诊疗中心、34家国家临床研究基地脾胃病科的科研力量，在消化领域优势病种循证文献大数据平台（I期）的基础上协同进行消化疾病循证大数据建设的工作平台。',
            changeflag:7,
            sequence:2,
        },
        {
            tit:'中医诊疗体系重构知识分析平台',
            cooperator:'长春中医药大学',
            txt:'中医学三大传统医学思想包括整体观、个体化和治未病，但作为传统的中医诊疗体系，存在着刻强轴弱、态强靶弱、个强群弱三种不足。',
            changeflag:7,
            sequence:3,
        },
        {
            tit:'《黄帝内经》理论研究工作平台',
            cooperator:'中国中医科学院中医基础理论研究所',
            txt:'《黄帝内经》分《灵枢》、《素问》两部分，是中国最早的医学典籍，传统医学四大经典著作之一。',
            changeflag:7,
            sequence:4,
        },
        {
            tit:'糖尿病足临床研究平台',
            cooperator:'中国中医科学院西苑医院',
            txt:'坚持以临床价值为导向，构建中医药理论、“人用经验”和临床试验“三结合”的中药审评证据体系，推动建立与中药临床定位相适应、体现其作用特点和优势的疗效评价标准，用“现代语”诠释中医药，正在成为新时期中医药迈向高质量发展的重要创新路径。',
            changeflag:7,
            sequence:5
        },   
        {
            tit:'帕金森病中医药专题知识库',
            cooperator:'广东省中医院',
            txt:'全面整合帕金森病相关古代和现代中医药文献和医案知识资源。',
            changeflag:7,
            sequence:6
        },
        {
            
            tit:'中医药知识图谱',
            cooperator:'中国中医科学院中医药信息研究所',
            txt:'中医药知识图谱由多个模块构成，包括疾病、诊疗方法、临床、养生、文献等内容，实现知识关联和知识融合，支撑智能推荐、智能问答等各种智能应用。',
            changeflag:7,
            sequence:7, 
        },
        {
            tit:'重点学科及学者知识分析系统',
            cooperator:'北京中医药大学',
            txt:'为了支撑国家中医药管理局中医药信息学重点学科科研条件建设，我们构建了中医临床信息学文献库，提供检索入口。',
            changeflag:7,
            sequence:8,
            href:'https://www.tcmkb.cn/tcmkb/pages/clinic_systems.jsp',
        },
        {
            tit:'赵炳南名医经验知识库',
            cooperator:'中国中医科学院中医药信息研究所',
            txt:'系统梳理中医名家赵炳南的学术思想、临证经验、特色用药、临床研究、医案和经验方，辅助中医学术传承。',
            changeflag:7,
            sequence:9
        },
    ]
}